<template>
    <a class="btn" :class="{'bg-grey hover:bg-grey cursor-default': disabled, 'cursor-pointer': !disabled}" @click.prevent="onSend">
        <slot>{{ text }}</slot>
    </a>
</template>

<script>
    import { call } from 'vuex-pathify'
    import { format } from 'date-fns'

    export default {
        props: {
            text: {
                type: String,
                default: 'Email PDF'
            },
        },

        data() {
            return {
                disabled: false,
            }
        },

        methods: {
            sendExportReport: call('charts/sendExportReport'),

            onSend() {
                if (!this.disabled) {
                    this.sendExportReport()
                }

                this.text = 'PDF sent'
                this.disabled = true
            },
        },
    }
</script>
